module.exports = __webpack_public_path__ + "img/RX-Arcos-2-zoom.166e24af.png";